if (document.body.contains(document.querySelector('fieldset.digital-download'))) {
  document.addEventListener("DOMContentLoaded", function() {
    const watchButton1 = document.getElementById('template--17412411162881__main-1-0'); // digital yes
    const watchButton2 = document.getElementById('template--17412411162881__main-1-1'); // digital no
    const watchButton3 = document.getElementById('template--17412411162881__main-1-2');
    const formatDiv = document.querySelector('fieldset.digital-download');
    const posterPrintSizeDiv = document.querySelector('fieldset.poster-print-size'); // poster print
    const posterNA = document.getElementById('template--17412411162881__main-2-0');
    const framedPrintSizeDiv = document.querySelector('fieldset.framed-print-size'); // framed print
    const framedNA = document.getElementById('template--17412411162881__main-3-0');

    watchButton1.checked = true;
    posterPrintSizeDiv.style.display = 'none';
    framedPrintSizeDiv.style.display = 'none';

    // if (watchButton1.checked == 1) {
    //   posterPrintSizeDiv.style.display = 'none';
    //   framedPrintSizeDiv.style.display = 'none';
    // }

    formatDiv.addEventListener('change', function() {
        if (watchButton1.checked == 1) {
            // console.log('digital');
            posterPrintSizeDiv.style.display = 'none';
            framedPrintSizeDiv.style.display = 'none';
            posterNA.checked = true;
            framedNA.checked = true;
        } else if (watchButton2.checked == 1) {
            // console.log('print');
            posterPrintSizeDiv.style.display = 'block';
            framedPrintSizeDiv.style.display = 'none';
            framedNA.checked = true;
        } else if (watchButton3.checked == 1) {
            posterPrintSizeDiv.style.display = 'none';
            framedPrintSizeDiv.style.display = 'block';
            posterNA.checked = true;
        }
    });
  });
}

// if (document.body.contains(document.querySelector('fieldset.format'))) {
//   document.addEventListener("DOMContentLoaded", function() {
//     const watchButton1 = document.getElementById('template--17412411162881__main-1-0');
//     const watchButton2 = document.getElementById('template--17412411162881__main-1-1');
//     const digitalDownloadDiv = document.querySelector('fieldset.format');
//     const posterPrintSizeDiv = document.querySelector('fieldset.poster-print-size');
//     const framedPrintSizeDiv = document.querySelector('fieldset.framed-print-size');

//     if (watchButton1.checked == 1) {
//       posterPrintSizeDiv.style.display = 'none';
//       framedPrintSizeDiv.style.display = 'none';
//     }

//     digitalDownloadDiv.addEventListener('change', function() {
//         if (watchButton1.checked == 1) {
//             posterPrintSizeDiv.style.display = 'none';
//             framedPrintSizeDiv.style.display = 'none';
//         } else if (watchButton2.checked == 1) {
//             posterPrintSizeDiv.style.display = 'block';
//             framedPrintSizeDiv.style.display = 'block';
//         }
//     });
//   });
// }

// document.addEventListener('DOMContentLoaded', function() {
//   const productForm = document.querySelector('form[action="/cart/add"]');
//   const productPrice = document.querySelector('.price-item.price-item--regular');

//   if (productForm && productPrice) {
//     productForm.addEventListener('change', function() {
//       console.log('changed');
//       const selectedVariant = JSON.parse(productForm.querySelector('option:checked').dataset.variant);
//       if (selectedVariant) {
//         productPrice.textContent = new Intl.NumberFormat('en-US', {
//           style: 'currency',
//           currency: selectedVariant.price.currency
//         }).format(selectedVariant.price.amount);
//       }
//     });
//   }
// });